import MarkdownIt from 'markdown-it';
import { MessageMarkdownTransformer } from '@chatwoot/prosemirror-schema';
import mentionPlugin from 'shared/helpers/markdownIt/link';

// Extend the installed Community transformer through its tokenizer API.
// This tokenizer is private: enabling mentions must not mutate other editors.
const mentionTokenizer = () =>
  MarkdownIt('commonmark', { html: false, linkify: false })
    .disable(['table', 'hr', 'heading', 'lheading'], true)
    .use(mentionPlugin);

export const createMentionTransformer = schema =>
  new MessageMarkdownTransformer(schema, mentionTokenizer());

export const serializeMention = (state, node) => {
  if (node.attrs.mentionType === 'all') state.write('[@all](mention://all)');
  else {
    const { mentionType, userId, userFullName } = node.attrs;
    const name = encodeURIComponent(userFullName)
      .replace(/\(/g, '%28')
      .replace(/\)/g, '%29');
    state.write(
      `[${state.esc(`@${userFullName}`)}](mention://${mentionType}/${userId}/${name})`
    );
  }
};

export const readMentionTargets = content => {
  const targets = {
    mentionedUserIds: [],
    mentionedTeamIds: [],
    mentionAll: false,
  };
  const visit = tokens =>
    tokens.forEach(token => {
      if (token.type === 'mention') {
        const { mentionType, userId } = token.mention;
        if (mentionType === 'all') targets.mentionAll = true;
        else {
          const key =
            mentionType === 'user' ? 'mentionedUserIds' : 'mentionedTeamIds';
          const id = Number(userId);
          if (Number.isSafeInteger(id) && !targets[key].includes(id))
            targets[key].push(id);
        }
      }
      if (token.children) visit(token.children);
    });
  visit(mentionTokenizer().parse(content || '', {}));
  return targets;
};
